import { SummaryConfig } from '@ddv/models';

export function getSummaryConfig(summaryConfig: SummaryConfig | undefined): SummaryConfig {
    if (!summaryConfig) {
        return {
            textSize: 12,
            isLineSeparatorEnabled: false,
            summaries: [],
        };
    }

    return summaryConfig;
}
